import cn from 'classnames'
import React from 'react'

//
import { SiteDataContext } from '../../components/page-wrapper'

import { getMicroCopy } from '../../utils/microcopy'
import IconNew from '../IconNew'
import { useMicroCopyData } from '@/src/context/MicroCopyContext'

const Notification = ({
  title = '',
  text = null,
  isOpen = false,
  handleClose = () => null,
  children,
  classes = ''
}) => {
  const microCopyData = useMicroCopyData()
  const { lang } = React.useContext(SiteDataContext)
  return (
    <div
      className={cn('c-notification', classes, {
        'is-open': isOpen
      })}
    >
      {title && <span className="c-notification__title">{title}</span>}

      {text && <div className="c-notification__text">{text}</div>}

      {children && <div className="c-notification__actions">{children}</div>}

      <button
        type="button"
        onClick={handleClose}
        className="c-notification__close"
        aria-label={getMicroCopy({ key: 'close', fallback: 'Close', data: microCopyData[lang] })}
      >
        <IconNew name="tabler-x" size={20} />
      </button>
    </div>
  )
}

export default Notification
